var _path, _path2, _path3, _path4, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForkThemeChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 46 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.267 8.977L11.223.933a1.313 1.313 0 00-1.856 0L1.324 8.977a1.312 1.312 0 000 1.856l8.043 8.043a1.313 1.313 0 001.856 0l8.043-8.043a1.312 1.312 0 000-1.856zM45.068 8.977L37.025.933a1.313 1.313 0 00-1.856 0l-8.043 8.044a1.312 1.312 0 000 1.856l8.043 8.043a1.313 1.313 0 001.856 0l8.043-8.043a1.312 1.312 0 000-1.856z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.577 10.905h25.52",
    stroke: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.097 9.905h24",
    stroke: "#165DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.577 8.905h25.52",
    stroke: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.295,
    cy: 9.905,
    r: 3,
    fill: "#165DFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.097,
    cy: 9.905,
    r: 3,
    fill: "#165DFF"
  })));
}
export default SvgForkThemeChecked;